import React from 'react';
import { Tag } from 'antd';
import type { AdminProductMaterialLabelProps } from '../../interfaces';
import './AdminProductMaterialLabel.scss';

const AdminProductMaterialLabel: React.FC<AdminProductMaterialLabelProps> = ({
  material,
  detailsLoaded,
  requiresSizes,
  materialStock,
  activeVariantCount,
  variantsCount,
}) => (
  <div className="admin-product-form__material-label">
    <div>
      <strong>{material.materialName}</strong>
      <span>${material.price}</span>
    </div>
    <div className="admin-product-form__material-badges">
      <Tag color={material.isAvailable ? 'blue' : 'default'}>
        {material.isAvailable ? 'Active' : 'Hidden'}
      </Tag>
      {detailsLoaded && <Tag>{materialStock} in stock</Tag>}
      {detailsLoaded && requiresSizes && (
        <Tag>{activeVariantCount}/{variantsCount} variants</Tag>
      )}
    </div>
  </div>
);

export default AdminProductMaterialLabel;
